export default "__VITE_ASSET__aXiIIRv___"